module.exports = __webpack_public_path__ + "send-fb.7f8385e4.jpg";